import React from 'react';

const UseCases = () => {
  const useCases = [
    {
      icon: '🛍️',
      title: 'Retail Stores',
      description: 'Send new arrivals, sales, and exclusive offers to customers who visited your store.'
    },
    {
      icon: '✂️',
      title: 'Salons & Spas',
      description: 'Send appointment reminders, beauty tips, and special packages to regular clients.'
    },
    {
      icon: '🍴',
      title: 'Restaurants & Cafes',
      description: 'Share menu updates, daily specials, and discount coupons to food lovers.'
    },
    {
      icon: '🏋️',
      title: 'Gyms & Fitness',
      description: 'Send workout plans, class schedules, and renewal reminders to members.'
    },
    {
      icon: '🏛️',
      title: 'Hotels & Resorts',
      description: 'Stay connected with guests, send booking confirmations and special packages.'
    },
    {
      icon: '💊',
      title: 'Clinics & Hospitals',
      description: 'Send appointment confirmations, health tips, and follow-up reminders.'
    },
    {
      icon: '🚗',
      title: 'Automobile Service',
      description: 'Send service reminders, offers on spare parts, and maintenance tips.'
    },
    {
      icon: '🏪',
      title: 'Local Shops',
      description: 'Build loyal customer base by sending personalized offers and updates.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Perfect For Every Business
          </h2>
          <p className="text-xl text-gray-600">
            No matter what you sell, MPillar AIQR Kit helps you stay connected with customers
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {useCases.map((useCase, index) => (
            <div key={index} className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 hover:shadow-lg transition-shadow border border-green-200">
              <div className="text-5xl mb-4">{useCase.icon}</div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{useCase.title}</h3>
              <p className="text-sm text-gray-600">{useCase.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">🚀 Real Results from Real Businesses</h3>
          <div className="grid md:grid-cols-4 gap-6 mt-8">
            <div>
              <p className="text-4xl font-bold mb-2">500+</p>
              <p className="text-green-100">Businesses Trust Us</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">50K+</p>
              <p className="text-green-100">WhatsApp Leads Collected</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">40%</p>
              <p className="text-green-100">Average Sales Increase</p>
            </div>
            <div>
              <p className="text-4xl font-bold mb-2">98%</p>
              <p className="text-green-100">Customer Satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCases;